import { extendTheme } from "@chakra-ui/react";

const sizes = {
  height: {
    small: "100px",
    medium: "200px",
    large: "350px",
    full: "100vh",
    screen: "calc(100vh-100px)",
  },
};

const borderWidth = {
  thick: "4px",
  medium: "2px",
  thin: "1.5px",
  light: "1px",
};

const componentStyled = {
  Modal: {
    sizes: {
      "6xl": {
        dialog: {
          maxWidth: "100rem",
        },
      },
    },
  },
  Table: {
    parts: ["th", "td"],
    baseStyle: {
      thead: {
        th: {
          color: "white",
          fontSize: "12px",
          backgroundColor: "bgColor",
          fontWeight: "400",
        },
      },
      tr: {
        borderBottomWidth: "thin",
        borderStyle: "solid",
        borderColor: "bgColor",
      },
      td: {
        fontSize: "14px",
        fontWeight: "normal",
      },
    },
  },
  Button: {
    baseStyle: {
      fontSize: "15px",
      textAlign: "center",
      border: "1px solid",
      borderColor: "bgColor",
      backgroundColor: "bgColor",
      color: "textColor",
      paddingX: 10,
      borderRadius: "none",
      _disabled: {
        background: "bgColor",
        color: "white",
        cusor: "not-allowed",
      },
    },
    variants: {
      loginButton: {
        fontSize: "lg",
        padding: 5,
        _hover: {
          background: "bgColor",
          color: "textColor",
        },
      },
      primaryButton: {
        fontSize: "sm",
        _hover: {
          background: "bgColor",
          color: "textColor",
        },
      },
    },
  },
  Input: {
    baseStyle: {
      field: {
        borderWidth: "light",
        borderStyle: "solid",
        borderColor: "bgColor",
        borderRadius: "none",
      },
    },
  },
  Select: {
    baseStyle: {
      field: {
        borderWidth: "light",
        borderStyle: "solid",
        borderColor: "bgColor",
        borderRadius: "none",
      },
    },
  },
  Tag: {
    variants: {
      primary: {
        container: {
          bg: "#e2e8f0",
          color: "black",
          borderRadius: "full",
          textAlign: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minWidth: "100px",
        },
      },
    },
  },
};

// Shared base config
const baseTheme = {
  sizes,
  borderWidths: borderWidth,
  styles: {
    global: {
      body: {},
    },
  },
  components: componentStyled,
};

// Theme per environment (only colors differ)
const defaultTheme = extendTheme({
  ...baseTheme,
  colors: {
    bgColor: "#3d1413", // dark brown/red
    textColor: "white",
    loginPannel: "#F0ECE3",
    borderColor: {
      default: "gray",
      focus: "#3d1413",
    },
  },
});

const devTheme = extendTheme({
  ...baseTheme,
  colors: {
    bgColor: "#4d84c7", // blue-ish
    textColor: "white",
    loginPannel: "#F0ECE3",
    borderColor: {
      default: "gray",
      focus: "#4d84c7",
    },
  },
});

const sandboxTheme = extendTheme({
  ...baseTheme,
  colors: {
    bgColor: "#008584", // teal
    textColor: "white",
    loginPannel: "#F0ECE3",
    borderColor: {
      default: "gray",
      focus: "#008584",
    },
  },
});

export { defaultTheme, devTheme, sandboxTheme };
